export default [
    { key: 'venue.name', label: 'Sede', sortable: false },
    { key: 'structure_type.name', label: 'Tipo', sortable: false },
    { key: 'name', label: 'Puesto / Servicio', sortable: false },
    { key: 'items', label: 'Items asignados', sortable: false },
    { key: 'actions', label: 'Asignación herramientas', sortable: false },
]